module.exports = __webpack_public_path__ + "45661fd89ac351825afb4b61faf95b89.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/headphones-s.png
// module id = 2766
// module chunks = 0